export default __webpack_public_path__ + "static/media/BoyIcon.77459a9e.svg";